//I GUESS THIS SHOULD BE IN THE PLUGIN - @TODO
let accordion = jQuery('.mortar-accordion__title a')

accordion.on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        thisParent = thisEl.parent()

    thisParent.toggleClass('open')

})

jQuery('.mortar-tabs__list li:first-child a').addClass('selected')

jQuery('.mortar-tabs__list a').on('click', function(e) {

    e.preventDefault()

    let parentLi = jQuery(this).parent()
    let parentLiIndex = parentLi.index()
    let wrapper = jQuery(this).parents('.mortar-tabs')

    wrapper.find('.mortar-tabs__list a').removeClass('selected')
    jQuery(this).addClass('selected')

    wrapper.find('.mortar-tabs__content').hide().eq(parentLiIndex).show()

});

jQuery(document).ready(function() {
    jQuery('.games-hub__editoreal-area p > img').each(function() {
        jQuery(this).unwrap().wrap('<figure></figure>');
    });
});
